import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { membersAPI, authAPI } from '../services/api';
import { getNavigationForRole } from './navigation';

const iconPaths = {
  dashboard: 'M3 13.5 12 4l9 9M5.25 11.25V20h13.5v-8.75',
  members: 'M16 11a4 4 0 1 0-8 0 4 4 0 0 0 8 0ZM3.5 20a6.5 6.5 0 0 1 13 0M18 8a3 3 0 1 1 0 6M18.5 20a5.5 5.5 0 0 0-2.2-4.4',
  deceased: 'M12 8.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 11.5c-3.38 0-6.5 1.69-6.5 4.75v.75h13v-.75c0-3.06-3.12-4.75-6.5-4.75Z',
  beneficiaries: 'M12 21s-6.75-4.35-9-9.3C1.5 7.8 4.2 4.5 8.1 4.5c1.7 0 3 .8 3.9 2 0-.1.1-.1.1-.2.9-1.1 2.2-1.8 3.8-1.8 3.9 0 6.6 3.3 5.1 7.2-2.25 4.95-9 9.3-9 9.3Z',
  payments: 'M3 7.5h18v9H3zM3 10.5h18M7.5 15h3',
  receipt: 'M9 14.25l1.5 1.5 3-3.75M12 3c-4.2 0-7.5 3.3-7.5 7.5S7.8 18 12 18s7.5-3.3 7.5-7.5S16.2 3 12 3zM8.25 7.5h7.5M8.25 10.5h7.5',
  claims: 'M7.5 4.5h9M7.5 8.25h9M6 3h12A1.5 1.5 0 0 1 19.5 4.5v15A1.5 1.5 0 0 1 18 21H6A1.5 1.5 0 0 1 4.5 19.5v-15A1.5 1.5 0 0 1 6 3Zm2.25 10.5 1.5 1.5 3.75-3.75',
  reports: 'M6.75 4.5h10.5A1.5 1.5 0 0 1 18.75 6v12a1.5 1.5 0 0 1-1.5 1.5H6.75A1.5 1.5 0 0 1 5.25 18V6a1.5 1.5 0 0 1 1.5-1.5Zm2.25 3.75h6m-6 3h6m-6 3h3',
  settings: 'M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  users: 'M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z',
  system: 'M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z',
};

function NavIcon({ name, className = 'h-5 w-5' }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className={className}>
      <path strokeLinecap="round" strokeLinejoin="round" d={iconPaths[name]} />
    </svg>
  );
}

function NavItem({ item, mobile = false, onNavigate }) {
  if (item.disabled) {
    return (
      <div title="Coming soon"
        className={mobile
          ? 'flex min-w-[72px] cursor-not-allowed flex-col items-center gap-1 rounded-2xl px-3 py-2 text-[11px] font-medium opacity-40'
          : 'group flex cursor-not-allowed items-center gap-3 rounded-2xl px-4 py-3 text-sm font-medium opacity-40'}>
        <span className={mobile
          ? 'flex h-8 w-8 items-center justify-center rounded-xl border border-white/15 bg-white/10 text-white'
          : 'flex h-8 w-8 items-center justify-center rounded-xl bg-white/10'}>
          <NavIcon name={item.icon} className={mobile ? 'h-4 w-4 shrink-0' : 'h-5 w-5'} />
        </span>
        <span className={mobile ? 'text-center leading-tight text-white/60' : 'text-white/60'}>{item.label}</span>
        {!mobile && (
          <span className="ml-auto rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-semibold text-white/50">
            Coming soon
          </span>
        )}
      </div>
    );
  }

  return (
    <NavLink to={item.path} end={item.path === '/'} onClick={onNavigate}
      className={({ isActive }) =>
        mobile
          ? `flex flex-1 min-w-0 flex-col items-center gap-0.5 rounded-xl px-1 py-1.5 text-[10px] font-medium transition-all ${isActive ? 'bg-white text-slate-900 shadow-lg' : 'text-white/70 hover:bg-white/10 hover:text-white'}`
          : `group flex items-center gap-3 rounded-2xl px-4 py-3 text-sm font-medium transition-all ${isActive ? 'bg-white text-slate-900 shadow-lg shadow-[#1b2857]/20' : 'text-white/72 hover:bg-white/10 hover:text-white'}`
      }>
      <span className={mobile
        ? 'flex h-8 w-8 items-center justify-center rounded-xl border border-white/15 bg-white/10 text-current'
        : 'flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10 transition-colors group-hover:bg-white/15'}>
        <NavIcon name={item.icon} className={mobile ? 'h-4 w-4 shrink-0' : 'h-5 w-5'} />
      </span>
      <span className={mobile ? 'text-center leading-tight' : ''}>{item.label}</span>
    </NavLink>
  );
}

function groupLinks(links) {
  const groups = [];
  let current = null;
  for (const item of links) {
    const key = item.section || null;
    if (!current || current.section !== key) {
      current = { section: key, items: [] };
      groups.push(current);
    }
    current.items.push(item);
  }
  return groups;
}

const MAX_VISIBLE = 4;

export function MobileNavBar() {
  const { user } = useAuthStore();
  const links = getNavigationForRole(user?.role, user?.permissions);
  const [moreOpen, setMoreOpen] = useState(false);

  const visibleLinks = links.slice(0, MAX_VISIBLE);
  const moreLinks    = links.slice(MAX_VISIBLE);
  const hasMore      = moreLinks.length > 0;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 lg:hidden">
      {/* Backdrop */}
      {moreOpen && (
        <div className="fixed inset-0 z-40" onClick={() => setMoreOpen(false)} />
      )}

      {/* Nav strip */}
      <nav className="relative z-50 border-t border-white/15 bg-[linear-gradient(90deg,#1b2857_0%,#4a1a06_60%,#f07415_100%)] shadow-[0_-4px_20px_rgba(15,23,42,0.25)] pb-[env(safe-area-inset-bottom)]">
        <div className="flex w-full items-end justify-around px-2 pb-1 pt-1">
          {visibleLinks.map((item) => (
            <NavItem key={item.path} item={item} mobile onNavigate={() => setMoreOpen(false)} />
          ))}
          {hasMore && (
            <button onClick={() => setMoreOpen((v) => !v)}
              className={`flex flex-1 min-w-0 flex-col items-center gap-0.5 rounded-xl px-1 py-1.5 text-[10px] font-medium transition-all ${moreOpen ? 'bg-white text-slate-900' : 'text-white/70 hover:bg-white/10 hover:text-white'}`}>
              <span className={`flex h-8 w-8 items-center justify-center rounded-xl border border-white/15 ${moreOpen ? 'bg-slate-100' : 'bg-white/10'}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-4 w-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              </span>
              More
            </button>
          )}
        </div>
      </nav>

      {/* More dropdown — opens upward, above the bottom bar */}
      {hasMore && moreOpen && (
        <div className="absolute inset-x-0 bottom-full z-50 px-3 pb-1">
          <div className="rounded-2xl border border-white/15 bg-[linear-gradient(160deg,#1b2857_0%,#4a1a06_60%,#f07415_100%)] p-3 shadow-[0_12px_40px_rgba(15,23,42,0.5)]">
            <p className="mb-2 px-2 text-[10px] font-semibold uppercase tracking-widest text-orange-200/60">More</p>
            <div className="grid grid-cols-4 gap-2">
              {moreLinks.map((item) => (
                <NavLink key={item.path} to={item.path} end={item.path === '/'} onClick={() => setMoreOpen(false)}
                  className={({ isActive }) =>
                    `flex flex-col items-center gap-1 rounded-xl px-1 py-2 text-center text-[11px] font-medium transition-colors ${isActive ? 'bg-white text-slate-900' : 'text-white/80 hover:bg-white/10'}`
                  }>
                  {({ isActive }) => (
                    <>
                      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${isActive ? 'bg-slate-100' : 'bg-white/10'}`}>
                        <NavIcon name={item.icon} className="h-4 w-4" />
                      </span>
                      <span className="leading-tight">{item.label}</span>
                    </>
                  )}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function Sidebar() {
  const { user, syncPermissions } = useAuthStore();
  const links = getNavigationForRole(user?.role, user?.permissions);
  const [memberPicture, setMemberPicture] = useState(null);
  const [rollNo, setRollNo] = useState(null);
  const [petitionNo, setPetitionNo] = useState(null);
  const [isLifeMember, setIsLifeMember] = useState(false);

  const displayName = user?.full_name || user?.name || 'AWTF User';
  const initial     = displayName[0]?.toUpperCase() ?? 'A';

  useEffect(() => {
    if (!user) return;
    if (user.role === 'member') {
      membersAPI.me()
        .then(m => {
          if (m?.picture) setMemberPicture(m.picture);
          if (m?.roll_no) setRollNo(m.roll_no);
          if (m?.petition_no) setPetitionNo(m.petition_no);
          setIsLifeMember(m?.membership_type === 'life');
        })
        .catch(() => {});
    } else {
      authAPI.profile()
        .then(p => {
          if (p?.picture) setMemberPicture(p.picture);
          syncPermissions(p?.permissions || []);
        })
        .catch(() => {});
    }
  }, [user]);

  return (
    <aside className="app-sidebar hidden lg:sticky lg:top-0 lg:flex lg:h-screen lg:w-80 lg:flex-col lg:self-start">
      <div className="mx-3 mt-2 mb-3 flex-1 min-h-0 rounded-[28px] border border-white/12 bg-[linear-gradient(160deg,#1b2857_0%,#4a1a06_60%,#f07415_100%)] p-4 text-white shadow-[0_24px_60px_rgba(15,23,42,0.28)] flex flex-col overflow-hidden">

        {/* ── Profile card ── */}
        <div className="rounded-[28px] border border-white/12 bg-white/8 p-5 backdrop-blur">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-orange-100/70">AWTF Portal</p>

          {/* Avatar */}
          <div className="mt-4 flex justify-center">
            <div className="relative h-20 w-20">
              <div className="h-20 w-20 rounded-2xl overflow-hidden ring-2 ring-white/20 shadow-lg bg-white/15">
                {memberPicture ? (
                  <img
                    src={memberPicture}
                    alt={displayName}
                    className="h-full w-full object-cover"
                    onError={() => setMemberPicture(null)}
                  />
                ) : (
                  <div className="h-full w-full flex items-center justify-center text-2xl font-black text-white">
                    {initial}
                  </div>
                )}
              </div>
              <span className="absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 rounded-full bg-emerald-400 ring-2 ring-[#1b2857]" />
            </div>
          </div>

          {isLifeMember && (
            <div className="mt-3 flex justify-center">
              <span className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-300 to-amber-500 px-3 py-1 text-[11px] font-bold text-amber-950 shadow-sm">
                🏆 Life Member
              </span>
            </div>
          )}

          {/* Name + role */}
          <div className="mt-3 text-center">
            <p className="text-base font-bold leading-tight">{displayName}</p>
            <span className="mt-1.5 inline-block rounded-full bg-white/15 px-3 py-0.5 text-[11px] font-semibold capitalize text-orange-100">
              {user?.role || 'member'}
            </span>
            {rollNo ? (
              <p className="mt-1.5 font-mono text-xs font-semibold tracking-widest text-white/50">
                #{rollNo}
              </p>
            ) : petitionNo ? (
              <p className="mt-1.5 font-mono text-xs font-semibold tracking-widest text-white/50">
                Petition #{petitionNo}
              </p>
            ) : null}
          </div>

          <div className="mt-4 border-t border-white/10" />

          <p className="mt-4 text-xs leading-5 text-slate-200/70">
            Navigate your workspace with clarity. Quick access to member records, benefits, payments, and claims in one place.
          </p>
        </div>

        {/* ── Nav ── */}
        <nav className="sidebar-nav-scroll mt-5 flex-1 min-h-0 space-y-4 overflow-y-auto pr-1">
          {groupLinks(links).map((group, i) => (
            <div key={group.section || `ungrouped-${i}`} className="space-y-1.5">
              {group.section && (
                <p className="px-4 text-[10px] font-bold uppercase tracking-[0.2em] text-orange-100/50">
                  {group.section}
                </p>
              )}
              <div className="space-y-1">
                {group.items.map((item) => (
                  <NavItem key={item.path} item={item} />
                ))}
              </div>
            </div>
          ))}
        </nav>
      </div>
    </aside>
  );
}
